import { MarvColor, MarvColorPrimary, MarvColorPurple, MarvColorBlue, MarvColorOrange, MarvColorRed, MarvColorGreen } from '@marv/types';

enum Status {    
    NONE, UNREAD, READ   
}

export class AlertMessageStatus {
    static readonly Status = Status;
    code: Status;
    name: string;
    icon: string;
    color: MarvColor = MarvColorPrimary;
    
    constructor(status: Status){
       this.code = status;
       this.init();
   }
   
   static FromAlertMessage(status: string): AlertMessageStatus {
       let alertMessageStatus: Status = Status.NONE;
        switch(status){
            case "UNREAD" :
                alertMessageStatus = Status.UNREAD ;
                break;
            case "READ" :
                alertMessageStatus = Status.READ;
                break;
        }
        return new AlertMessageStatus(alertMessageStatus);  
   }
   
   init() {
        let name = '';
        let icon = '';
        let color:MarvColor = MarvColorPrimary;
        switch(this.code){
            case Status.UNREAD :
                name = "MESSAGE_UNREAD";
                icon = "mail-unread-outline";
                color = MarvColorPurple;
                break;
            case Status.READ :
                name = "MESSAGE_READ";
                icon = "mail-open-outline";
                color = MarvColorPrimary;
                break;            
        }       
        this.name = name;
        this.icon = icon;
        this.color = color;
    }
}

enum Type {    
    NONE, INFO, WARNING, ERROR, SUCCESS   
}

export class AlertMessageType {
    static readonly Type = Type;
    code: Type;
    icon: string;
    color: MarvColor = MarvColorPrimary;
    
    constructor(type: Type){
       this.code = type;
       this.init();
   }
   
   static FromAlertMessage(type: string): AlertMessageType {
       let alertMessageType: Type = Type.NONE;
        switch(type){
            case "INFO" :
                alertMessageType = Type.INFO ;
                break;
            case "WARNING" :
                alertMessageType = Type.WARNING;
                break;
            case "ERROR" :
                alertMessageType = Type.ERROR;
                break;
            case "SUCCESS" :
                alertMessageType = Type.SUCCESS;
                break;
        }
        return new AlertMessageType(alertMessageType);  
   }
   
   init() {       
        let icon = '';
        let color:MarvColor = MarvColorPrimary;
        switch(this.code){
            case Type.INFO :               
                icon = "information-circle-outline";
                color = MarvColorBlue;
                break;
            case Type.WARNING :                
                icon = "warning-outline";
                color = MarvColorOrange;
                break;            
            case Type.ERROR :                
                icon = "close-circle-outline";
                color = MarvColorRed;
                break;            
            case Type.SUCCESS :                
                icon = "checkmark-circle-outline";
                color = MarvColorGreen;
                break;            
        }  
        this.icon = icon;
        this.color = color;
    }
}

export class AlertMessage {
    type: AlertMessageType;
    title: string;
    body: string;
    date: Date;
    status: AlertMessageStatus;
}